import * as React from 'react'
import { Breadcrumbs as MaterialBreadcrumbs, Link } from '@mui/material'

import { Breadcrumb } from '../types'

import '../styles/Breadcrumbs.scss'

export interface Props {
	breadcrumbs: Breadcrumb[]
}

export interface Actions {
	onBreadcrumbClick: (breadcrumb: Breadcrumb) => void
}

export default class Breadcrumbs extends React.PureComponent<Props & Actions> {

	_onBreadcrumbClick = (item: Breadcrumb) => () => {
		this.props.onBreadcrumbClick(item)
	}

	render() {
		const { breadcrumbs } = this.props

		return (
			<MaterialBreadcrumbs
				className="breadcrumbs"
				separator={<span className="breadcrumbs__icon icon-arrow_drop_up" />}
			>
				{breadcrumbs.map((item, index) => {
					const isLastItem = index === breadcrumbs.length - 1
					const isClickable = !!(item.isClickable && !isLastItem)
					return (
						<Link
							key={item.title}
							color="secondary"
							underline="none"
							onClick={isClickable ? this._onBreadcrumbClick(item) : undefined}
							className={`breadcrumb${isClickable ? ' breadcrumb--clickable' : ''}${isLastItem ? ' breadcrumb--end' : ''}`}
						>
							{item.title}
						</Link>
					)
				})}
			</MaterialBreadcrumbs>
		)
	}
}